export enum SessionFilters {
  LocalStartTime = 'localStartTime',
  Venue = 'venue',
  Field = 'field',
  HomeTeam = 'homeTeam',
  Level = 'level',
  League = 'league',
  GameReference = 'gameReference',
}
